module.exports = __webpack_public_path__ + "img/76.90d8260a.png";